module.exports = " <div class=content _v-15630612=\"\"> <top _v-15630612=\"\"></top> <router-view _v-15630612=\"\"></router-view> <my-footer _v-15630612=\"\"></my-footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-15630612!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wuyan/index.vue
// module id = 196
// module chunks = 1